/* =========================================================
   NOEMA — theme.js
   ========================================================= */
(function () {
  'use strict';

  var money = function (cents) {
    var fmt = window.NOEMA && window.NOEMA.moneyFormat ? window.NOEMA.moneyFormat : '${{amount}}';
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, int + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, int)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
  };

  /* Run a callback once per element, even if boot() fires again
     after a theme-editor section reload. */
  function each(selector, flag, fn) {
    document.querySelectorAll(selector).forEach(function (el) {
      if (el.dataset[flag]) return;
      el.dataset[flag] = '1';
      fn(el);
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.rv:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Mobile nav ---------- */
  function initNav() {
    var drawer = document.querySelector('[data-mnav]');
    if (!drawer) return;

    function close() {
      drawer.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
    }

    each('[data-mnav-open]', 'navOpenBound', function (b) {
      b.addEventListener('click', function () {
        drawer.classList.add('is-open');
        document.body.classList.add('no-scroll');
      });
    });

    each('[data-mnav-close]', 'navCloseBound', function (b) {
      b.addEventListener('click', close);
    });

    if (!drawer.dataset.navEscBound) {
      drawer.dataset.navEscBound = '1';
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
      });
    }
  }

  /* ---------- Announcement rotator ---------- */
  function initAnn() {
    each('[data-ann-slider]', 'annBound', function (box) {
      var slides = box.querySelectorAll('.ann-slide');
      if (slides.length < 2) return;
      var i = 0;
      setInterval(function () {
        slides[i].classList.remove('is-on');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-on');
      }, parseInt(box.dataset.annSlider, 10) || 4500);
    });
  }

  /* ---------- Stock bar ---------- */
  function initStock() {
    var bars = document.querySelectorAll('[data-stock-fill]:not([data-stock-done])');
    if (!bars.length) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.dataset.stockDone = '1';
          e.target.style.width = e.target.dataset.stockFill + '%';
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.4 });
    bars.forEach(function (b) { io.observe(b); });
  }

  /* ---------- Counters ---------- */
  function initCount() {
    var els = document.querySelectorAll('[data-count]:not([data-count-done])');
    if (!els.length) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var node = e.target;
        node.dataset.countDone = '1';
        var target = parseFloat(node.dataset.count);
        var suffix = node.dataset.countSuffix || '';
        var prefix = node.dataset.countPrefix || '';
        var dur = 1400, t0 = null;
        function step(ts) {
          if (!t0) t0 = ts;
          var p = Math.min((ts - t0) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = Math.round(target * eased);
          node.textContent = prefix + val.toLocaleString('en-US') + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Hotspots / tabs ---------- */
  function initHotspots() {
    each('[data-hotspots]', 'hsBound', function (root) {
      var tabs = root.querySelectorAll('[data-hs-tab]');
      var panels = root.querySelectorAll('[data-hs-panel]');
      var imgs = root.querySelectorAll('[data-hs-img]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var k = tab.dataset.hsTab;
          tabs.forEach(function (t) { t.classList.toggle('is-on', t === tab); });
          panels.forEach(function (p) { p.classList.toggle('is-on', p.dataset.hsPanel === k); });
          imgs.forEach(function (i) { i.classList.toggle('is-on', i.dataset.hsImg === k); });
        });
      });
    });
  }

  /* ---------- Gallery dots ---------- */
  function initGalDots() {
    each('[data-gal-scroll]', 'galBound', function (track) {
      var dots = track.parentElement.querySelectorAll('[data-gal-dot]');
      if (!dots.length) return;
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / (track.scrollWidth / dots.length));
        dots.forEach(function (d, n) { d.classList.toggle('is-on', n === Math.min(i, dots.length - 1)); });
      }, { passive: true });
    });
  }

  /* ---------- Bundle / variant selector ---------- */
  function initBundles() {
    each('[data-bundle]', 'bundleBound', function (root) {
      var form = document.getElementById(root.dataset.bundle);
      var opts = root.querySelectorAll('.bopt');
      opts.forEach(function (opt) {
        opt.addEventListener('click', function () {
          if (opt.classList.contains('is-off')) return;
          var input = opt.querySelector('input');
          if (!input) return;
          input.checked = true;
          opts.forEach(function (o) { o.classList.toggle('is-on', o === opt); });
          if (form) {
            var idField = form.querySelector('[name="id"]');
            var qtyField = form.querySelector('[name="quantity"]');
            if (idField && input.dataset.variantId) idField.value = input.dataset.variantId;
            if (qtyField && input.dataset.qty) qtyField.value = input.dataset.qty;
            form.dataset.gifts = input.dataset.gifts || '';
            document.querySelectorAll('[data-live-price]').forEach(function (p) {
              if (input.dataset.price) p.textContent = money(parseInt(input.dataset.price, 10));
            });
          }
          if (input.dataset.variantId) {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', input.dataset.variantId);
            window.history.replaceState({}, '', url);
          }
        });
      });

      // Seed the form with the pre-checked offer (gifts included).
      var checked = root.querySelector('input:checked');
      if (checked && form) {
        var idf = form.querySelector('[name="id"]');
        var qf = form.querySelector('[name="quantity"]');
        if (idf && checked.dataset.variantId) idf.value = checked.dataset.variantId;
        if (qf && checked.dataset.qty) qf.value = checked.dataset.qty;
        form.dataset.gifts = checked.dataset.gifts || '';
      }
    });
  }

  /* ---------- Add to cart with free gifts ---------- */
  function initGiftCart() {
    each('[data-product-form]', 'giftFormBound', function (form) {
      form.addEventListener('submit', function (ev) {
        var gifts = (form.dataset.gifts || '')
          .split(',')
          .map(function (g) { return g.trim(); })
          .filter(Boolean);
        if (!gifts.length) return; // plain Shopify submit

        ev.preventDefault();
        var idField = form.querySelector('[name="id"]');
        var qtyField = form.querySelector('[name="quantity"]');
        if (!idField) return;

        var items = [{ id: Number(idField.value), quantity: Number(qtyField && qtyField.value) || 1 }];
        gifts.forEach(function (g) {
          items.push({ id: Number(g), quantity: 1, properties: { _gift: 'true' } });
        });

        var btn = form.querySelector('[data-atc]');
        var label = btn && btn.querySelector('[data-atc-label]');
        var restore = label && label.textContent;
        if (btn) btn.disabled = true;
        if (label) label.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.data && res.data.description ? res.data.description : 'add failed');
            window.location.href = '/cart';
          })
          .catch(function () {
            // Gift product unavailable — fall back to the main item only.
            if (btn) btn.disabled = false;
            if (label && restore) label.textContent = restore;
            form.dataset.gifts = '';
            if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
          });
      });
    });
  }

  /* ---------- Simple variant radios ---------- */
  function initVariants() {
    each('[data-variant-picker]', 'vpBound', function (root) {
      var data = root.querySelector('[data-variant-json]');
      if (!data) return;
      var variants = JSON.parse(data.textContent);
      var form = document.getElementById(root.dataset.variantPicker);
      root.addEventListener('change', function () {
        var chosen = Array.prototype.map.call(root.querySelectorAll('input:checked'), function (i) { return i.value; });
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === chosen[i]; });
        });
        if (!match) return;
        if (form) {
          var idField = form.querySelector('[name="id"]');
          if (idField) idField.value = match.id;
          var btn = form.querySelector('[data-atc]');
          if (btn) {
            btn.disabled = !match.available;
            var label = btn.querySelector('[data-atc-label]');
            if (label) {
              label.textContent = match.available
                ? (btn.dataset.labelAdd || 'Add to cart')
                : (btn.dataset.labelSold || 'Sold out');
            }
          }
        }
        document.querySelectorAll('[data-live-price]').forEach(function (p) { p.textContent = money(match.price); });
        document.querySelectorAll('[data-live-compare]').forEach(function (p) {
          if (match.compare_at_price > match.price) {
            p.textContent = money(match.compare_at_price);
            p.classList.remove('hide');
          } else { p.classList.add('hide'); }
        });
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      });
    });
  }

  /* ---------- Sticky ATC ---------- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;
    var anchor = document.querySelector('[data-atc-anchor]');
    if (!anchor || anchor.dataset.satcBound) return;
    anchor.dataset.satcBound = '1';

    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); });
    }, { threshold: 0 });
    io.observe(anchor);

    each('[data-sticky-submit]', 'satcBtnBound', function (b) {
      b.addEventListener('click', function (ev) {
        ev.preventDefault();
        var form = document.querySelector('[data-product-form]');
        if (!form) return;
        if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
      });
    });
  }

  /* ---------- Cart qty ---------- */
  function initQty() {
    each('[data-qty]', 'qtyBound', function (box) {
      var input = box.querySelector('input');
      if (!input) return;
      box.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var step = b.hasAttribute('data-qty-up') || b.dataset.step === 'up' ? 1 : -1;
          var min = parseInt(input.min, 10);
          if (isNaN(min)) min = 0;
          var v = Math.max(min, (parseInt(input.value, 10) || 0) + step);
          input.value = v;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          if (box.dataset.qty === 'cart') {
            var f = box.closest('form');
            if (f) f.submit();
          }
        });
      });
    });
  }

  /* ---------- Accordion: close siblings ---------- */
  function initAcc() {
    each('[data-acc-exclusive]', 'accBound', function (root) {
      var items = root.querySelectorAll('details');
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          items.forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  /* Video cards — click the cover to start playing, pause the others. */
  function initVideoCards() {
    document.querySelectorAll('[data-video]').forEach(function (card) {
      if (card.dataset.vcBound) return;
      card.dataset.vcBound = '1';
      var cover = card.querySelector('[data-video-cover]');
      var vid = card.querySelector('video');
      if (!cover || !vid) return;
      cover.addEventListener('click', function () {
        document.querySelectorAll('[data-video] video').forEach(function (v) {
          if (v !== vid) v.pause();
        });
        card.classList.add('is-playing');
        vid.play();
      });
      vid.addEventListener('ended', function () { card.classList.remove('is-playing'); });
    });
  }

  /* Daily countdown — always ends at midnight US Eastern time, then restarts. */
  function initBundleTimer() {
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    var fmt;
    try {
      fmt = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' });
    } catch (e) { fmt = null; }

    function secondsToMidnight() {
      var h, m, s, now = new Date();
      if (fmt) {
        var p = {};
        fmt.formatToParts(now).forEach(function (x) { p[x.type] = x.value; });
        h = (+p.hour) % 24; m = +p.minute; s = +p.second;
      } else {
        h = now.getHours(); m = now.getMinutes(); s = now.getSeconds();
      }
      var left = 86400 - (h * 3600 + m * 60 + s);
      return left <= 0 ? 86400 : left;
    }

    var els = [];
    document.querySelectorAll('[data-btimer]').forEach(function (el) {
      if (el.dataset.btBound) return;
      var hEl = el.querySelector('[data-btimer-h]');
      var mEl = el.querySelector('[data-btimer-m]');
      var sEl = el.querySelector('[data-btimer-s]');
      if (!hEl || !mEl || !sEl) return;
      el.dataset.btBound = '1';
      els.push([hEl, mEl, sEl]);
    });
    if (!els.length) return;

    function tick() {
      var t = secondsToMidnight();
      var hh = pad(Math.floor(t / 3600)), mm = pad(Math.floor((t % 3600) / 60)), ss = pad(t % 60);
      els.forEach(function (x) { x[0].textContent = hh; x[1].textContent = mm; x[2].textContent = ss; });
    }

    tick();
    setInterval(tick, 1000);
  }

  function boot() {
    initReveal();
    initNav();
    initAnn();
    initStock();
    initCount();
    initHotspots();
    initGalDots();
    initBundles();
    initGiftCart();
    initVariants();
    initStickyAtc();
    initQty();
    initAcc();
    initVideoCards();
    initBundleTimer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', boot);
})();
